<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <!-- <b-button tag="router-link" :to="{ name: 'Das' }" type="is-dark">Terug naar overzicht</b-button> -->
            </div>
            <div class="column small-9">
                <h1>Accountinstellingen</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form verticalpadding">
                    <div class="row">
                        <div class="column">
                            <h4>Opstarten</h4>
                            <b-field label="Standaardpagina (na inloggen pagina openen)">
                                <b-select expanded v-model="settings.loginredirect">
                                    <option :value="1">Dashboard</option>
                                    <option :value="2">Boxen lijstweergave</option>
                                    <option :value="3">Boxen plattegrond</option>
                                    <option :value="4">Contracten</option>
                                    <option :value="5">Facturen</option>
                                    <option :value="6">Klanten</option>
                                </b-select>
                            </b-field>
                            <b-field label="Privacy modus (na inloggen gevoelige data verbergen)">
                                <b-select expanded v-model="settings.sensitivedata">
                                    <option :value="1">Aan</option>
                                    <option :value="0">Uit</option>
                                </b-select>
                            </b-field>

                            <br>

                            <div v-if="user && user.organisation_type && user.organisation_type == 'box'">
                                <h4>Plattegrond</h4>
                                <b-field label="Voorkeur openen box overzicht">
                                    <b-select expanded v-model="settings.open_preference">
                                        <option :value="1" v-show="settings.loginredirect != 3" :disabled="settings.loginredirect == 3">Open de lijst weergave</option>
                                        <option :value="3" v-show="settings.loginredirect != 2" :disabled="settings.loginredirect == 2">Open eerst gedefinieerde plattegrond</option>
                                        <option :value="4" v-show="settings.loginredirect != 2" :disabled="settings.loginredirect == 2">Open de laatst geopende plattegrond</option>
                                    </b-select>
                                </b-field>

                                <b-field label="Klikken op box actie">
                                    <b-select expanded v-model="settings.clickbox">
                                        <option :value="1">Box details</option>
                                        <option :value="2">Contract aanmaken</option>
                                    </b-select>
                                </b-field>
                            </div>

                            <div v-if="$store.state.user.organisation_type && $store.state.user.organisation_type == 'box'">
                                <br>

                                <h4>Boxen</h4>
                                <b-field label="Openen van een box">
                                    <b-select expanded v-model="settings.open_box">
                                        <option :value="0">Opent tab "Algemeen"</option>
                                        <option :value="1">Opent tab "Klant"</option>
                                        <option :value="2">Opent tab "Contract"</option>
                                        <option :value="3">Opent tab "Facturen"</option>
                                        <option :value="4" v-show="user.role == 'pit' && user.organisation_connect || settings.open_box == 5">Opent tab "Toegang"</option>
                                        <!-- <option :value="5">Opent tab "Logs"</option> -->
                                    </b-select>
                                </b-field>
                            </div>

                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="column text-right">
                <div class="formfooter">
                    <b-button type="is-success" :loading="loading" @click="save">Opslaan</b-button>
                    <!-- <b-button type="is-dark" :loading="loading" @click="saveAndQuit">Opslaan en sluiten</b-button> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import toastMixin from '@/mixins/toastMixins'

export default {
    name: 'UserSettings',

    mixins: [toastMixin],

    data() {
        return {
            loading: false,
            settings: {}
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        }
    },

    created() {
        // Handle settings that might be a JSON string or object
        let userSettings = this.$store.state.user.settings

        if (typeof userSettings === 'string' && userSettings.length > 0) {
            try {
                userSettings = JSON.parse(userSettings)
            } catch (e) {
                console.warn('Failed to parse user settings:', e)
                userSettings = {}
            }
        }

        this.settings = JSON.parse(JSON.stringify(userSettings)) || {}

        // Defaults if not set
        if (!_.has(this.settings, 'loginredirect')) {
            this.settings.loginredirect = 1
        }
        if (!_.has(this.settings, 'sensitivedata')) {
            this.settings.sensitivedata = 1
        }
        if (!_.has(this.settings, 'open_preference')) {
            this.settings.open_preference = 1
        }
        if (!_.has(this.settings, 'clickbox')) {
            this.settings.clickbox = 1
        }
        if (!_.has(this.settings, 'open_box')) {
            this.settings.open_box = 0
        }
    },

    methods: {
        save() {
            this.loading = true

            axios.post('/api/user/save', {settings: {...this.settings}}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.$store.dispatch('saveUserSettings', response.data)
                this.$buefy.toast.open({message: 'Succesvol opgeslagen!', type: 'is-success'})
            }).catch((error) => {
                console.error('[❌] Error while saving user:', error)
                this.showError('Daar gaat iets fout! Probeer het nogmaals.')
            }).then(() => {
                this.loading = false
            })

            this.showMessage('Opgeslagen!')
        }
    },

    watch: {
        'settings.loginredirect': function(newVal) {
            // Box lijstweergave
            if(newVal == 2) {
                if(this.settings.open_preference != 1){
                    this.settings.open_preference = 1
                }
            }

            // Box plattegrond
            if(newVal == 3){
                if(this.settings.open_preference == 1){
                    this.settings.open_preference = 3
                }
            }
        }
    }
}
</script>